<template>
  <div class="course__card_box" v-if="[25, 30].includes(activeTab) && courseList.length">
    <div class="title">专属课程</div>
    <div class="course__tabs" v-if="showTabs">
      <div
        v-for="tab in visibleTabs"
        :key="tab.key"
        class="course__tab"
        :class="{ 'is-active': activeCourseTab === tab.key }"
        @click="setCourseTab(tab.key)"
      >
        {{ tab.label }}
      </div>
    </div>
    <ul>
      <li v-for="(item, keys) in displayList" :key="item.productId || keys">
        <course-card :isUnlock="isUnlock" :item="item"></course-card>
      </li>
    </ul>
  </div>
</template>

<script>
import { reqProducts } from '@/api/home';
import { resetProductData } from '@/utils/tools';
import CourseCard from './CourseCard.vue';

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    productIds: {
      type: Array,
      default: () => [],
    },
    activeTab: {
      type: Number,
      default: 20,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 基础会员 25 中阶会员 30 高阶会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
  },
  components: {
    CourseCard,
  },
  data() {
    return {
      courseList: [],
      activeCourseTab: 'ebook',
      tabList: [
        { key: 'ebook', label: '电子书' },
        { key: 'course', label: '课程' },
      ],
    };
  },
  watch: {
    productIds: {
      handler(value) {
        if (value && value.length) {
          const endPoint = this.$root.$data.isApp ? 2 : 4;
          reqProducts(value, endPoint).then((res) => {
            if (res.code === 0) {
              this.courseList = resetProductData(res.data);
              this.syncActiveTab();
            }
          });
        } else {
          this.courseList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    isUnlock() {
      const { level } = this.userMemberInfo;
      const { id } = this.userInfo;
      if (!id) return false;
      if (this.activeTab === 20) return [10, 20, 40, 50, 60].includes(level);
      if (this.activeTab === 25) return level === 25;
      if (this.activeTab === 30) return level === 30;
      return false;
    },
    ebookList() {
      return this.courseList.filter(item => Number(item.isEbook) === 1);
    },
    normalCourseList() {
      return this.courseList.filter(item => Number(item.isEbook) !== 1);
    },
    visibleTabs() {
      return this.tabList.filter((tab) => {
        if (tab.key === 'ebook') return this.ebookList.length;
        return this.normalCourseList.length;
      });
    },
    showTabs() {
      return this.visibleTabs.length > 1;
    },
    displayList() {
      if (this.activeCourseTab === 'ebook' && this.ebookList.length) {
        return this.ebookList;
      }
      if (this.activeCourseTab === 'course' && this.normalCourseList.length) {
        return this.normalCourseList;
      }
      return this.ebookList.length ? this.ebookList : this.normalCourseList;
    },
  },
  methods: {
    setCourseTab(key) {
      this.activeCourseTab = key;
    },
    syncActiveTab() {
      const hasEbook = this.ebookList.length > 0;
      const hasCourse = this.normalCourseList.length > 0;
      if (this.activeCourseTab === 'ebook' && hasEbook) return;
      if (this.activeCourseTab === 'course' && hasCourse) return;
      this.activeCourseTab = hasEbook ? 'ebook' : 'course';
    },
  },
};

</script>

<style scoped lang="scss">
.course__card_box {
  .title {
    height: 40px;
    margin-bottom: 22px;
    margin-left: 36px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 40px;
  }

  ul {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    &::-webkit-scrollbar {
      display: none;
    }

    li {
      display: inline-block;
      margin-right: 18px;

      &:first-child {
        margin-left: 36px;
      }

      &:last-child {
        margin-right: 36px;
      }

      // background: #fff;
      // border-radius: 18px;
    }
  }
}

.course__tabs {
  display: flex;
  margin: 0 0 22px 36px;
}

.course__tab {
  width: 156px;
  height: 56px;
  margin-right: 18px;
  color: #333;
  font-size: 25px;
  line-height: 56px;
  white-space: nowrap;
  text-align: center;
  background-color: #f1f2f6;
  border-radius: 7px;

  &.is-active {
    color: #fff;
    background-color: #ff7f41;
  }
}
</style>
